import {
  EmployerFormsPageV2,
  InitiateGroupPage,
  InitiateProposalPage,
  TriggerRenewalsPage,
  ZywaveGroupInfoPage,
} from 'pages';
import QuoteAddEmployeesPage from 'pages/quote/add-employees/QuoteAddEmployees';
import QuoteAddEmployeesCensusUploadPage from 'pages/quote/add-employees/CensusUploadPage';
import QuoteAddEmployeesCensusReviewPage from 'pages/quote/add-employees/CensusReviewPage';
import QuoteAddEmployeesFullFormPage from 'pages/quote/add-employees/FullFormPage';
import IMQAddEmployeesFullFormPage from 'pages/quote/imq-add-employees/FullFormPage';
import ImqBrokerHealthQuestionnaireEntryPage from 'pages/quote/imq-add-employees/HealthQuestionnaireEntryPage';
import ImqBrokerHealthQuestionnairePage from 'pages/quote/imq-add-employees/HealthQuestionnairePage';
import ImqBrokerMedicalCategoryPage from 'pages/quote/imq-add-employees/MedicalCategoryPage';
import ImqBrokerEmploymentDetailsPage from 'pages/quote/imq-add-employees/EmploymentDetailsPage';
import QuoteChecklistPage from 'pages/quote/QuoteChecklistPage';
import QuoteProposalInfoPage from 'pages/quote/quote-proposal-info';
import BrowsingPage from 'pages/BrowsingPage';
import GroupHubPage from 'pages/GroupHubPage';
import EnrollmentChecklistPage from 'pages/enrollment/ChecklistPage';
import ZywaveQuoteRedirectPage from 'pages/zywave/ZywaveQuoteRedirectPage';
import AddQuotePage from 'pages/quote/AddQuotePage';
import AccountSettingsPage from 'pages/user-settings/AccountSettingsPage';
import NotificationSettingsPage from 'pages/user-settings/NotificationSettingsPage';
import IMQCensusReviewPage from 'pages/quote/imq-add-employees/IMQCensusReviewPage';
import IMQAddEmployeesPage from 'pages/quote/imq-add-employees/IMQAddEmployees';
import IMQCensusUploadPage from 'pages/quote/imq-add-employees/IMQCensusUploadPage';
import DownloadIMQsPage from 'pages/quote/DownloadIMQs';
import SubscriberHealthQuestionnaireEntryPage from 'pages/subscriber/imq/HealthQuestionnaireEntry';
import SubscriberHealthQuestionnairePage from 'pages/subscriber/imq/HealthQuestionnaire';
import SubscriberHealthQuestionnaireMedicalCategoryPage from 'pages/subscriber/imq/MedicalCategoryPage';
import SubscriberIMQSubscriberProfilePage from 'pages/subscriber/imq/IMQSubscriberProfile';
import SubscriberIMQSubscriberDependentsPage from 'pages/subscriber/imq/IMQSubscriberDependents';
import EmploymentDetailsPage from 'pages/subscriber/imq/EmploymentDetails';
import EmployerProfilePage from 'pages/employer/EmployerProfilePage';
import EmployeeProfilePage from 'pages/subscriber/EmployeeProfilePage';
import UploadAllExhibitsPage from 'pages/tools/UploadAllExhibitsPage';
import QuoteOverrideRatesPage from 'pages/quote/QuoteOverrideRatesPage';
import QuoteOverrideRatesPlanPage from 'pages/quote/QuoteOverrideRatesPlanPage';
import EstimatedCostPage from 'pages/quote/EstimatedCostPage';
import {
  EnrollmentRouteV2Id,
  GeneralRouteV2Id,
  QuoteRouteV2Id,
  RouteV2Id,
  UserSettingsRouteV2Id,
  SubscriberRouteV2Id,
  ZywaveRouteV2Id,
  ToolsRouteV2Id,
} from './routesConfigV2';

const GENERAL_COMPONENTS: Record<GeneralRouteV2Id, React.ComponentType> = {
  [GeneralRouteV2Id.INITIATE_GROUP]: InitiateGroupPage,
  [GeneralRouteV2Id.INITIATE_PROPOSAL]: InitiateProposalPage,
  [GeneralRouteV2Id.GROUP_HUB]: GroupHubPage,
  [GeneralRouteV2Id.EMPLOYER_PROFILE]: EmployerProfilePage,
};

const USER_SETTINGS_COMPONENTS: Record<UserSettingsRouteV2Id, React.ComponentType> = {
  [UserSettingsRouteV2Id.ACCOUNT_SETTINGS]: AccountSettingsPage,
  [UserSettingsRouteV2Id.NOTIFICATION_SETTINGS]: NotificationSettingsPage,
};

const ZYWAVE_COMPONENTS: Record<ZywaveRouteV2Id, React.ComponentType> = {
  [ZywaveRouteV2Id.ZYWAVE_GROUP_INFO]: ZywaveGroupInfoPage,
};

const QUOTE_COMPONENTS: Record<QuoteRouteV2Id, React.ComponentType> = {
  [QuoteRouteV2Id.QUOTE_CHECKLIST]: QuoteChecklistPage,
  [QuoteRouteV2Id.QUOTE_PROPOSAL_INFO]: QuoteProposalInfoPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_UPLOAD]: QuoteAddEmployeesCensusUploadPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_CENSUS_REVIEW]: QuoteAddEmployeesCensusReviewPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES_FULL_FORM]: QuoteAddEmployeesFullFormPage,
  [QuoteRouteV2Id.QUOTE_ADD_EMPLOYEES]: QuoteAddEmployeesPage,
  [QuoteRouteV2Id.ZYWAVE_QUOTE_REDIRECT]: ZywaveQuoteRedirectPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES]: IMQAddEmployeesPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_CENSUS_UPLOAD]: IMQCensusUploadPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_CENSUS_REVIEW]: IMQCensusReviewPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_FULL_FORM]: IMQAddEmployeesFullFormPage,
  [QuoteRouteV2Id.DOWNLOAD_IMQS]: DownloadIMQsPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_HEALTH_QUESTIONNAIRE_ENTRY]: ImqBrokerHealthQuestionnaireEntryPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_HEALTH_QUESTIONNAIRE]: ImqBrokerHealthQuestionnairePage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_HEALTH_QUESTIONNAIRE_MEDICAL_CATEGORY]: ImqBrokerMedicalCategoryPage,
  [QuoteRouteV2Id.IMQ_ADD_EMPLOYEES_EMPLOYMENT_DETAILS]: ImqBrokerEmploymentDetailsPage,
  /**
   * `/browsing` is still used when adding a plan from Add Quote.
   * Quote checklist cards INITIATE_SHELF_BROWSING and INITIATE_SHELF_ADD_QUOTE both open Add Quote
   * (see QUOTE_CHECKLIST_MAPPING) so existing prod checklists that still use BROWSING keep working.
   */
  [QuoteRouteV2Id.INITIATE_SHELF_BROWSING]: BrowsingPage,
  [QuoteRouteV2Id.INITIATE_SHELF_ADD_QUOTE]: AddQuotePage,
  [QuoteRouteV2Id.QUOTE_OVERRIDE_RATES]: QuoteOverrideRatesPage,
  [QuoteRouteV2Id.QUOTE_OVERRIDE_RATES_PLAN]: QuoteOverrideRatesPlanPage,
  [QuoteRouteV2Id.QUOTE_ESTIMATED_COST]: EstimatedCostPage,
};

const ENROLLMENT_COMPONENTS: Record<EnrollmentRouteV2Id, React.ComponentType> = {
  [EnrollmentRouteV2Id.EMPLOYER_FORMS]: EmployerFormsPageV2,
  [EnrollmentRouteV2Id.ENROLLMENT_CHECKLIST]: EnrollmentChecklistPage,
};

const SUBSCRIBER_COMPONENTS: Record<SubscriberRouteV2Id, React.ComponentType> = {
  [SubscriberRouteV2Id.EMPLOYEE_PROFILE]: EmployeeProfilePage,
  [SubscriberRouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE_ENTRY]: SubscriberHealthQuestionnaireEntryPage,
  [SubscriberRouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE]: SubscriberHealthQuestionnairePage,
  [SubscriberRouteV2Id.SUBSCRIBER_HEALTH_QUESTIONNAIRE_MEDICAL_CATEGORY]:
    SubscriberHealthQuestionnaireMedicalCategoryPage,
  [SubscriberRouteV2Id.SUBSCRIBER_EMPLOYMENT_DETAILS]: EmploymentDetailsPage,
  [SubscriberRouteV2Id.SUBSCRIBER_IMQ_SUBSCRIBER_PROFILE]: SubscriberIMQSubscriberProfilePage,
  [SubscriberRouteV2Id.SUBSCRIBER_IMQ_SUBSCRIBER_DEPENDENTS]: SubscriberIMQSubscriberDependentsPage,
};

const TOOLS_COMPONENTS: Record<ToolsRouteV2Id, React.ComponentType> = {
  [ToolsRouteV2Id.TRIGGER_RENEWALS]: TriggerRenewalsPage,
  [ToolsRouteV2Id.UPLOAD_ALL_EXHIBITS]: UploadAllExhibitsPage,
};

/**
 *  This map contains the new V2 routes mapping to their respective components
 *  Please break them down flow-wise: general, rfq, template, etc.
 */
export const ROUTE_COMPONENTS_MAP: Record<RouteV2Id, React.ComponentType> = Object.freeze({
  ...GENERAL_COMPONENTS,
  ...USER_SETTINGS_COMPONENTS,
  ...ZYWAVE_COMPONENTS,
  ...QUOTE_COMPONENTS,
  ...ENROLLMENT_COMPONENTS,
  ...SUBSCRIBER_COMPONENTS,
  ...TOOLS_COMPONENTS,
});
